
import ApLink from '@/components/APLink.vue'

export default {
  name: 'PayOnline',
  components: {
    ApLink
  },
  computed: {
    revalidationStatus() {
      return this.$store.state.revalidationStatus
    }
  }
}
